export const ProjectType = [
  { key: 1, value: "ساختمان و ابنیه" },
  { key: 2, value: "نفت و گاز" },
  { key: 3, value: "آب و فاضلاب" },
  { key: 4, value: "راه و ترابری" },
  { key: 5, value: "تاسیسات و تجهیزات" },
  { key: 6, value: "نیرو" },
  { key: 7, value: "کشاورزی" },
  { key: 8, value: "صنعت و معدن" },
  { key: 9, value: "ارتباطات" },
  { key: 10, value: "سایر" }
];
